// Client reviews for the Reflections carousel. All from Google Reviews.
// `quote` is the trimmed line shown in the carousel; `full` is kept for
// reference only (not displayed) in case a future page wants the long form.
// Adding a review is a data entry here, not a markup change.
const REVIEWS = [
  {
    name: "Cindy Haynes",
    stars: 5,
    date: "2 years ago",
    quote: "I only planned for one room, and now I'm doing them all. I can't thank her and her team enough for finding 'me'. I LOVE COMING HOME!",
    full: "I could go on for days about the amazing talent of Meliza Veloz Designs. Her team created a living space for my home that goes well beyond expectations. I've had the same look since I moved into the house over 25 years ago. And it simply didn't feel like me anymore. I actually didn't even know what 'me' was. Through her compassionate and personal attention to the process, to her expertise in the design and selection of the individual pieces and to the care and precision through the installation, my home is magnificent. I LOVE COMING HOME!!!! I only planned for one room, and now I'm doing them all. I can't thank her and her team enough for finding 'me'. I wish Google had 100 stars; I'd give her all of them."
  },
  {
    name: "Czannin Karla Javier",
    stars: 5,
    date: "11 months ago",
    quote: "They take the time to understand the vibe you're going for, and then they bring it to life in a way that just makes sense. Nothing felt forced. It all just clicked."
  },
  {
    name: "Venessa Cabrera",
    stars: 5,
    date: "11 months ago",
    quote: "Meliza and Elayna helped me design my baby's nursery. They were so patient. They took the time to see my vision and made it even better."
  },
  {
    name: "Gregory Gephart",
    stars: 5,
    date: "2 months ago",
    quote: "I wanted a yard that accommodated my little girl and my grill-master needs. Meliza and her team gave me that and more. They simplified the process and communicated every step of the way."
  },
  {
    name: "Elaine Coughlin",
    stars: 5,
    date: "10 months ago",
    quote: "From day one I was treated as a valuable client even though my job was not a total design. Each person I had contact with worked to make my vision a reality."
  },
  {
    name: "Marcus Evans",
    stars: 5,
    date: "2 years ago",
    quote: "The entire design process was smooth, efficient, and collaborative. I would not hesitate to recommend you to anyone looking for an interior designer."
  },
  {
    name: "Noel Veloz",
    stars: 5,
    date: "2 months ago",
    quote: "Sixth Sense Studio helped design my place and did a phenomenal job. The team was professional, detail-oriented, and truly brought my vision to life."
  }
];
